import React from 'react';
import './AdminTableAnswersForType3.scss';
//import {printQuizesCategory} from "../../../../../utils/helps.js";
import TableAnswersForType3 from './TableAnswersForType3/TableAnswersForType3';
import { openAddInputFormsForAnswersType3  } from '../../../adminSlice';

export default class AdminTableAnswersForType3 extends React.Component {
    constructor(props) {
        super(props);
        
        this.onAdd = this.onAdd.bind(this);
    }

    onAdd() {
        const { dispatch } = this.props;
    
        dispatch(openAddInputFormsForAnswersType3());
    
    }
    render() {
        let style;
       // console.log(this.props.adminState.dataSubCategoryId.length);
        if (this.props.adminState.selectedQuestion) {
          
                style = ''
            } else {
                style = 'disabled'
            }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableAnswersForType3">
                   <p className='tableName'>Список боксов {this.props.adminState.selectedQuestion} вопроса </p>

                   <TableAnswersForType3 
                   dispatch={dispatch}
                   data={this.props.adminState.dataAnswersIdForType3}
                   />

                   <button className='addButton' onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button> 

                    


                
            </div>
        )
    }
}